import { useEffect, useState, FunctionComponent } from 'react';
import { Button, Dialog, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { Typography } from '../../tailwindcomponents';
import lineApi from '../../api/line';
import { AllLineHandoverReports, LineHandoverReturnReportObj } from '../../types/line';
import { Edit, Search, Visibility } from '../../components/icons';
import HandoverDialogContext from './HandoverDialogContext';

type LineHandoverProps = {
  allTails: Array<string>,
  isLineSupervisorAdmin: Boolean,
  setLoading: Function
}

const LineHandover: FunctionComponent<LineHandoverProps> = ({ allTails, isLineSupervisorAdmin, setLoading }) => {

  const [reports, setReports] = useState(Array<AllLineHandoverReports>());
  const [handoverDialogOpen, setHandoverDialogOpen] = useState(false);
  const [lineHandoverReport, setLineHandOverReport] = useState<LineHandoverReturnReportObj>();

  useEffect(() => {
    setLoading(true);
    lineApi.getAllLineHandoverReports().then(res => {
      setReports(res.data);
      setLoading(false);
    });
  }, [handoverDialogOpen]);

  const refresh = (reportId: number) => {
    setLoading(true);
    lineApi.getLineHandoverReportByID(reportId).then(res => {
      if (res.status === true) {
        setLineHandOverReport(res.data);
        setHandoverDialogOpen(true);
      }
      setLoading(false);
    });
  }
  const onClickRow = (reportId: number, type: 'VIEW' | 'EDIT') => {
    setLoading(true);
    lineApi.getLineHandoverReportByID(reportId).then(res => {
      if (res.status === true) {
        setLineHandOverReport(res.data);
        setHandoverDialogOpen(true);
      }
      setLoading(false);
    });
  }
  const onCreateNewHandoverReport = () => {
    setLoading(true);
    lineApi.CreateNewLineHandoverReport().then(res => {
      if (res.status === false) {
        alert("Employee is not registered correctly in Staff Management");
      } else {
        refresh(res.data);
      }
      setLoading(false);
    });
  }

  const generateTableBody = (row: AllLineHandoverReports, index: number) => {
    return (
      <TableRow >
        <TableCell>{row.created_date_text} : {row.is_day_shift ? "Day" : "Night"}</TableCell>
        <TableCell>{row.supervisor_name}</TableCell>
        <TableCell>{row.shift_letter}</TableCell>
        <TableCell>{row.issues_count}</TableCell>
        <TableCell>{row.employees_count}</TableCell>
        <TableCell >
          {row.is_submitted && <Search className="cursor-pointer" onClick={() => onClickRow(row.id, "VIEW")} color='primary' />}
          {!row.is_submitted && isLineSupervisorAdmin && <Edit onClick={() => onClickRow(row.id, "EDIT")} color='primary' className="cursor-pointer" />}
          {!row.is_submitted && !isLineSupervisorAdmin && <Visibility onClick={() => onClickRow(row.id, "EDIT")} color='primary' className="cursor-pointer" />}
        </TableCell>
      </TableRow>
    )
  }
  return (
    <div className="p-3">
      <Typography variant={'h1'} align={'center'} text={"Line Handover reports"} />
      {!(reports.filter(s => !s.is_submitted).length > 0) && isLineSupervisorAdmin && <Button variant="text" color='primary' onClick={() => onCreateNewHandoverReport()}>Create new</Button>}
      <Table
        headers={["Created", "Created By", "Shift", "Issues", "Employees", "Submitted"]}
        rows={reports}
        generateBody={(row: any, index: number) => generateTableBody(row, index)}
        defaultRowsPerPage={25}
        pagination={true}
        skipIndexCol={true}
      />
      <Dialog visible={handoverDialogOpen} max_width={"xl"} strict={false} show_options={false}
        onClose={(status: any) => setHandoverDialogOpen(false)}
        title={"Create new Handover"}
        context={
          <HandoverDialogContext isLineSupervisorAdmin={isLineSupervisorAdmin} allTails={allTails} lineHandoverReport={lineHandoverReport!} refresh={(id: number) => refresh(id)} onClose={() => setHandoverDialogOpen(false)} />
        }
      />
    </div>
  );
};
export default LineHandover;